import { render, staticRenderFns } from "./balanceDetail.vue?vue&type=template&id=58a756da&scoped=true&"
import script from "./balanceDetail.vue?vue&type=script&lang=js&"
export * from "./balanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./balanceDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./balanceDetail.vue?vue&type=style&index=1&id=58a756da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a756da",
  null
  
)

export default component.exports